import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { PROCUREMENT_MODEL_NAV_ITEMS } from '../constants/homeSections';
import './mega-menu/procurement-nav.css';

export default function ProcurementModelsNavPanel({ onItemClick, variant = 'dropdown' }) {
  const { t } = useLanguage();
  const isMobile = variant === 'mobile';

  return (
    <nav
      className={`procurement-nav${isMobile ? ' procurement-nav--mobile' : ''}`}
      aria-label={t('procurementModels')}
    >
      <ul className="procurement-nav__list" role={isMobile ? undefined : 'menu'}>
        {PROCUREMENT_MODEL_NAV_ITEMS.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              role={isMobile ? undefined : 'menuitem'}
              onClick={() => onItemClick(item)}
              className="procurement-nav__item"
              data-testid={`${isMobile ? 'mobile-' : ''}nav-procurement-${item.id}`}
            >
              <span className="procurement-nav__icon-wrap" aria-hidden>
                <img
                  src={item.iconSrc}
                  alt=""
                  className="procurement-nav__icon"
                  width={48}
                  height={48}
                  loading="lazy"
                  decoding="async"
                />
              </span>
              <span className="procurement-nav__label">{t(item.labelKey)}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
